import { toast } from 'react-toastify';
import { api } from '@/api';
import { certificateApiRes } from '@/api/interfaces/responses';
import { certificateApiReq } from '@/api/interfaces/requests';
import { ICertificateStore } from '@/store/interfaces/Certificate';
import { NAME_STATUS_API_ORDER } from '../../Applications/consts';
import { TYPES_CERTIFICATE } from '../const';
import { IPrintValue } from '../interfaces';


export const countCheckedCertificates = (data: any) => {
  let count: number = 0;
  if (data.length > 0) {
    data.forEach((item: Record<string, any>) => {
      if (item.flag && item.id) {
        count += 1;
      }
    });
  }
  return count;
}

export const isOneOfCertificatesBlock = ( data: any ) => {
  let result = false;
  if (data.length > 0) {
    data.forEach(( item: Record<string, any> ) => {
      if (
        item.flag &&
        (item.status === TYPES_CERTIFICATE.USED ||
        item.status === TYPES_CERTIFICATE.RETURN)
      ) {
        result = true;
      }
    });
  }

  return result;
};

export const getCheckedCertificateIds = (data: any) => {
  let ids: string[] = []
  if (data.length !== 0) {
    data.forEach((item: Record<string, any>) => {
      if (item.flag && item.id) {
        ids.push(item.id)
      }
    })
  }
  return ids;
}
export const getCertificatesForPrint = (arr: ICertificateStore[], value: IPrintValue): certificateApiReq.IPrintCertificatesReq[] => {
  let arrId: certificateApiReq.IPrintCertificatesReq[] = [];
  if (arr.length >= 1) {
    arr.forEach((item) => {
      if (item.flag && item.id) {
        arrId.push({
          ...value,
          certificate_id: item.id
        });
      }
    });
  }

  return arrId;
};

export const handleClickIsPrint = async (arr: certificateApiReq.IPrintCertificatesReq[]): Promise<certificateApiRes.IPrintCertificatesRes[]> => {
  let response: any;
  if (arr.length === 0) {
    toast.error('Необходимо выбрать сертификаты!');
  } else {
    response = api.certificate.printCertificates(arr);

    toast.promise(
      response,
      {
        pending: NAME_STATUS_API_ORDER.PRINT_CERTIFICATES.PENDING,
        success: {
          render(res: Record<string, any>) {            
            if (res.length === 0) {
              toast.success(NAME_STATUS_API_ORDER.PRINT_CERTIFICATES.ERROR_ITEM);
            }
            return NAME_STATUS_API_ORDER.PRINT_CERTIFICATES.SUCCESS;
          }
        },
        error: {
          render(res: Record<string, any>) {
            const { status } = res.data.response;
            if (status === 500 || status === 501 || status === 502 || status === 503) {
              toast.error(NAME_STATUS_API_ORDER.PRINT_CERTIFICATES.ERROR_500 + status);
            }
            return NAME_STATUS_API_ORDER.PRINT_CERTIFICATES.ERROR;
          }
        }
      });
  }
  return response;
};

export const checkEmailUser = (certificates: Array<Record<string, any>>): boolean => {
  return certificates.filter((certificates: Record<string, any>) => certificates.flag).every((item: Record<string, any>) => {
    return item.customer ? !!item.customer.email : false;
  });
};